import { render, staticRenderFns } from "./NewCompound.vue?vue&type=template&id=8e55c956&scoped=true&"
import script from "./NewCompound.vue?vue&type=script&lang=js&"
export * from "./NewCompound.vue?vue&type=script&lang=js&"
import style0 from "./NewCompound.vue?vue&type=style&index=0&id=8e55c956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e55c956",
  null
  
)

export default component.exports